import axios from 'axios'
import type { AxiosInstance } from 'axios'

const API_BASE_URL = '/api'

// Debug: Log the API base URL to console
console.log('🔧 API Base URL:', API_BASE_URL)
console.log('🔧 VITE_API_URL env:', import.meta.env.VITE_API_URL)

export const api: AxiosInstance = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  }
})

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('authToken')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

// Handle response errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('authToken')
      window.location.href = '/login.html'
    }
    return Promise.reject(error)
  }
)

export default api
